import Service from "../Service";

const resource = "packingarmedbox/";

export default {
    save(cmp, requestID){
        return Service.post(resource + "save", cmp,{
            params: {requestID: requestID},
        });
    },
    pagination(dtr, requestID){
        return Service.post(resource + "pagination", dtr,{
            params:{requestID: requestID},
        });
    },
    list(fas, requestID) {
        return Service.post(resource + "list", fas, {
          params: { requestID: requestID },
        });
    },
    listperiods(fas, requestID) {
        return Service.post(resource + "listperiods", fas, {
          params: { requestID: requestID },
        });
    },

}